import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, map, throwError } from 'rxjs';

import { environment } from '@env';
import { FormInstanceRaw, FormSteps, FormSubmitParams } from '@shared/models/form-instance';
import { BackendService } from '@shared/services/backend.service';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  stepperState$ = new BehaviorSubject<FormSteps>({});

  constructor(private backendService: BackendService) {}

  public fetchFormLookupDetails(dataId: string): Observable<FormInstanceRaw> {
    return this.backendService.get<FormInstanceRaw>(`${environment.captureService}/${dataId}`).pipe(
      map((response) => response),
      catchError((errorRes) => throwError(() => errorRes)),
    );
  }

  public submitFormData(formSubmissionId: string, formData: FormSubmitParams): Observable<FormInstanceRaw> {
    return this.backendService.update<FormInstanceRaw>(`${environment.captureService}/${formSubmissionId}?action=submit`, formData).pipe(
      map((response) => response),
      catchError((errorRes) => throwError(() => errorRes)),
    );
  }
}
